import React, {useRef, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import numeral from 'numeral';
import TextClamp from 'react-string-clamp';
import {Typography, Button} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import AfficheImage from 'components/Shared/AfficheImage';
import Context from 'utils/Context';

import './FilmCard.scss';

const FilmCard = ({film, onClick}) => {
  const ref = useRef(null);
  const {t} = useTranslation();
  const {appState} = useContext(Context);

  const w = ref.current ? ref.current.clientWidth : 0;
  const style = {
    transform: `scale(${w / 300})`,
  };
  return (
    <div className="film-card" key={film.film_id} ref={ref} onClick={onClick}>
      <div className="film-card-inner">
        <AfficheImage affiche={film.affiche} ratio={0.7} alt={`${film.film_name} poster`} />
        <div className="film-card-wrapper" style={style}>
          {film.infos_sticker && <div className="film-sticker">{film.infos_sticker}</div>}
          <div className="film-card-overlay">
            <div className="film-card-overlay-inner">
              <div className="film-card-overlay-desc">
                <Typography variant="h6" align="center" className="titre-film" component="div">
                  <TextClamp text={film.film_name || ''} lines={3} />
                </Typography>
                {appState.conf.SHOW_RATING === 1 && film.infos_note && parseFloat(film.infos_note) > 0 && (
                  <Typography variant="h6" align="center" component="h3" fontSize="small" className="note-film">
                    <Rating value={parseFloat(film.infos_note)} precision={0.1} readOnly />
                  </Typography>
                )}
                <Typography variant="body1" className="genre-film" component="p" align="center">
                  {film.infos_genre} -{' '}
                  {parseInt(film.infos_duree / 60) + 'h' + numeral(film.infos_duree % 60).format('00')}
                </Typography>
                <Typography variant="body1" className="annee-film" component="p" align="center">
                  {film.infos_annee_prod && moment(film.infos_annee_prod).format('YYYY')}
                </Typography>
              </div>
              <Button className="seance-btn" color="primary" size="small" variant="contained">
                {t('plus-dinfos')}
              </Button>
              <Button className="seance-btn" color="primary" size="small" variant="contained">
                {t('voir-la-bande-annonce')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilmCard;
